 /*
   * Shopify Common JS
   *
   */

   
  if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
  }
  
  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @return {String} value - formatted value
   */
	Shopify.formatMoney = function(cents, format){
    if (format == null || format == undefined){
       format = window.globalVariables.money_format || "$";
    }
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) {
      
      return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) { return 0; }
      number = (number/100.0).toFixed(precision);
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return formatString.replace(placeholderRegex, value);
};

let productSlider = null;

/**
  * prevent body Touch event in Touch devices when Overlay is visible
  *
  * @param {event} event - event instance
*/
function bodyTouchMove(event){
  let currentTarget = event.target;
  if (!currentTarget.closest('[data-touch-moveable]')) {
    event.preventDefault();
    return false;
  }
}

/**
  * Limit the number of times a function is called within defined timeout
  *
  * @param {form} form - Form to serialize
*/
const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

/**
  * Fetch call config
  *
  * @param {string} type - request Accept type
*/
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/**
  * Open Modal javscript trigger
  *
  * */
function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 function dropDownInit(element){
 
  let dropdownParent = element.parentElement;
  const _this = element;

  ["mouseover", "focusin",  "click", "mouseout"].forEach(function(type){
    if(type == 'click'){
      dropdownParent.addEventListener(type, (e) => {
        e.stopPropagation();
        let currentTarget = e.currentTarget;
        let liveTarget = e.target;
        if(liveTarget.classList.contains('nav-link-title')){
          let linkHref = currentTarget.querySelector('.nav-link').getAttribute('data-href');
          if(linkHref) window.location.href = linkHref;
        }else{
          if (liveTarget && !liveTarget.closest('[data-touch-moveable]') || type == 'click') {
            if (liveTarget.closest('.submenu-toggle')) {
              dropdownToggle(dropdownParent);
            }
          }else{
            dropdownToggle(dropdownParent);
          }
        }
      });
    }else if(type == 'mouseout'){
      dropdownParent.addEventListener(type, (e) => {
        let currentTarget = e.currentTarget;
        if(!currentTarget.closest('[data-touch-moveable]')){
          e.stopPropagation();
          dropdownHide(dropdownParent);
        }
      });
    } else if(type == 'mouseover' || type == 'focusin'){
      dropdownParent.addEventListener(type, (e) => {
        let currentTarget = e.currentTarget;
        if(!currentTarget.closest('[data-touch-moveable]')){
          dropdownShow(dropdownParent); 
        }
      });
      _this.addEventListener(type, (e) => { ChildonFocusChange(dropdownParent); });
    }
  });

  dropdownParent.addEventListener('keyup', (event) => {
    if (event.code.toUpperCase() === 'ESCAPE'){ dropdownHide(event.currentTarget); }
    if (event.code.toUpperCase() === 'ENTER'){ dropdownShow(event.currentTarget); }
  });

  function dropdownToggle(dropdownParent) {
    let isActive = dropdownParent.classList.contains('open');
    setTimeout(function(){
      if(!isActive){ dropdownShow(dropdownParent); }
      else if(isActive){ dropdownHide(dropdownParent); }
    }, 50);
  }

  function dropdownShow(dropdownParent){
    _this.setAttribute('aria-expanded', true);
    if(!dropdownParent.closest('[data-role="drawer"]')){
      dropdownParent.classList.add('open');
    }else{
      Utility.toggleElement(dropdownParent, 'open');
    }
  }

  function dropdownHide(dropdownParent){
    _this.setAttribute('aria-expanded', false);
    if(!dropdownParent){
      return;
    }

    if(!dropdownParent.closest('[data-role="drawer"]')){
      dropdownParent.classList.remove('open');
    }else{
      Utility.toggleElement(dropdownParent, 'close');
    }
    if(event && event.type == 'mouseout' && dropdownParent.parentElement.closest('.dropdown')){
      dropdownParent.parentElement.closest('.dropdown').classList.remove('open');
    }

    let childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if(childDropdowns.length > 0){
      childDropdowns.forEach(function(child){
        child.classList.remove('open');
        if(child.querySelector('a[data-toggle="open"]'))
          child.querySelector('a[data-toggle="open"]').setAttribute('aria-expanded', false);
      });
    }
  }

  function ChildonFocusChange(dropdownParent){
    let _this = this;
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    let currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      let eleIndex = openDropdowns.indexOf(ele);
      if(eleIndex != currentIndex){ dropdownHide(ele); }
    });
  }

  let closeBtn = dropdownParent.querySelector('.close-submenu');
  if(closeBtn){
    closeBtn.addEventListener('click', (event)=>{
      event.preventDefault();
      let parentElement = event.currentTarget.closest('.dropdown');
      dropdownToggle(parentElement);
    });
  };
}

const allDropdowns = document.querySelectorAll('a[is="drop-down"]');
allDropdowns.forEach(function(ele) {
  dropDownInit(ele)
});

/**
 * Close SubMenu Dropdowns on Regular Nav Item fous or click
 *
 * @param {element} element - Dropdown element
 */
function defaultNavItem(element){
  let _this = element;
  ["focusin", "click", "mouseover", "mouseout"].forEach(function(type){
    _this.addEventListener(type, (e) => {
      let currentTarget = e.currentTarget;
      if(!currentTarget.closest('[data-touch-moveable]')){
        hideDropdown(_this.parentElement);
      }
    });
  });

  ["click", "touchend"].forEach(function(type){
    _this.addEventListener(type, (e) => {
      e.stopPropagation();
    });
  });

  function hideDropdown(dropdownParent){
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    openDropdowns.forEach((ele) => {
      ele.classList.remove('open');
      ele.querySelector('[is="drop-down"]').setAttribute('aria-expanded', false);
    });
  }
}

const allDefaultNav = document.querySelectorAll('a[is="simple-menu-item"]');
allDefaultNav.forEach(function(ele) {
  defaultNavItem(ele);
});

/**
* Mobile Navigation Drawer
*/
class MobileNavigation extends HTMLElement {
  constructor() {
    super();

    this.touchstartX = 0;
    this.touchendX = 0;

    this.openeBy = document.querySelector('#mobile-menu');
    this.closeBy = this.querySelector('.close-mobile--navbar');
    this.navDrawer = this.querySelector('#mobile-menu-drawer');
    this.bindEvents();
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(event){
    let isOpen = this.navDrawer.classList.contains('opened-drawer');
    if (!this.contains(event.relatedTarget) && isOpen == true) {
      this.closeBy.dispatchEvent(new Event('click'));
    }
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;
    this.closeBy.dispatchEvent(new Event('click'));
  }

  /**
   * bind click event to Menu Icon 
   * bind keyup event to Menu Drawer component
   */
  bindEvents() {
    this.openeBy.addEventListener('click', this.openMenuDrawer.bind(this));
    this.closeBy.addEventListener('click', this.closeMenuDrawer.bind(this));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.openeBy.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Open Menu Drawer
   *
   * @param {event} Event instance
   */


//   function trapFocus(container) {
//     if (!container) return;

//     var focusableElements = container.querySelectorAll(
//         'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
//     );
//     var firstFocusableElement = focusableElements[0];
//     var lastFocusableElement = focusableElements[focusableElements.length - 1];

//     function handleFocus(event) {
//         if (event.target === firstFocusableElement && event.shiftKey) {
//             event.preventDefault();
//             lastFocusableElement.focus();
//         } else if (event.target === lastFocusableElement && !event.shiftKey) {
//             event.preventDefault();
//             firstFocusableElement.focus();
//         }
//     }

//     function handleKeydown(event) {
//         if (event.key === 'Tab') {
//             handleFocus(event);
//         }
//     }

//     container.addEventListener('keydown', handleKeydown);
//     container.setAttribute('data-trap-focus', 'true');
// }
// function removeTrapFocus(container) {
//     if (!container) return;
//     var previouslyFocusedElement = container.getAttribute('data-prev-focus');
//     if (previouslyFocusedElement) {
//         document.querySelector(previouslyFocusedElement)?.focus();
//         container.removeAttribute('data-prev-focus');
//     }
// }
  openMenuDrawer(event) {
    this.navDrawer.classList.add('opened-drawer');
    siteOverlay.prototype.showOverlay();
    if(document.querySelector('ajax-cart.cart-drawer').classList.contains('opened-drawer')){
      document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }
    if(event){
      event.preventDefault();
      let openBy = event.currentTarget;
      openBy.setAttribute('aria-expanded', true);
      Utility.trapFocus(this.navDrawer, this.querySelector('.mobile-header--logo'));
      Utility.forceFocus(this.querySelector('.mobile-header--logo'));
    }
  }

  /**
   * Close Menu Drawer
   *
   * @param {event} Event instance
   */
  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      event.preventDefault();
      this.navDrawer.classList.remove('opened-drawer');
      siteOverlay.prototype.hideOverlay();

      let openDropdowns = Array.from(document.querySelectorAll('#mobile-menu-drawer .dropdown.open'));
      openDropdowns.forEach((ele) => {
        ele.classList.remove('open');
        ele.querySelector('[is="drop-down"]').setAttribute('aria-expanded', false);
      });

      this.openeBy.setAttribute('aria-expanded', false);
      Utility.forceFocus(this.openeBy);
    }
  }

  /**
   * To get User Touch action pattern (Swipe Left / Swipe Right)
   *
   */
  handleGesture() {
    if (this.touchendX < this.thistouchstartX)
      this.openeBy.dispatchEvent(new Event('click'));
    if (this.touchendX > this.touchstartX)
      this.closeBy.dispatchEvent(new Event('click'));
  }
}
customElements.define("mobile-nav", MobileNavigation);

/**
 * Modal Dialogue
 *
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = document.querySelectorAll('[data-modal-opener="'+this.id+'"]');
    if(this.modalOpeners.length > 0) {
      this.modalOpeners.forEach((opener)=>{
        opener.addEventListener('click', ()=>{
          this.show(opener);
        });
      });
    }

    if(this.querySelector('[id^="ModalClose-"]')){
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this)
      );
    }

    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });

    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });

  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    siteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.querySelector('[id^="ModalClose-"]'));
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    document.body.classList.remove('overflow-hidden');
    this.modal.classList.remove('open');
    siteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);

    if(this.id == 'PopupModal-video' && document.getElementsByTagName('custom-video')){
      this.querySelector('.video-section').innerHTML = '';
      document.querySelector('custom-video').classList.remove('show--video');
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
* Website Overlay for Mobile Menu and Cart Drawer
*/
class siteOverlay extends HTMLElement{
  constructor() {
    super();

    this.menuDrawer = document.querySelector('#mobile-menu-drawer');
    this.cartDrawer = document.querySelector('ajax-cart.cart-drawer');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   * @param {event} Event instance performed
   */
  onClick(event){
    if(this.cartDrawer && this.cartDrawer.classList.contains('opened-drawer')){
      document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }
    if(this.menuDrawer && this.menuDrawer.classList.contains('opened-drawer')){
      document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
    }
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    document.getElementById('site-overlay').classList.add('overlay--body');
    document.querySelector('body').classList.add('scroll-fixed');
    document.body.style.overflowY = "hidden";
    document.body.addEventListener('touchmove', bodyTouchMove, false);
  }

  /**
   * Hide overlay 
   */
  hideOverlay(){
    document.getElementById('site-overlay').classList.remove('overlay--body');
    document.querySelector('body').classList.remove('scroll-fixed');
    document.body.style.overflowY = "auto";
    document.body.removeEventListener('touchmove', bodyTouchMove, false);
  }
}
customElements.define("site-overlay", siteOverlay);

/**
 * Slider Component
 *
 */
 class sliderElement extends HTMLElement{
  constructor() {
    super();
    let sliderElement = this.querySelector('.swiper-slider');
    if(!sliderElement) return;
    
    let sliderOptions = sliderElement.getAttribute('data-slider');
    let thumbSlider;
    sliderOptions = JSON.parse(sliderOptions);

    // Set up nav slider 
    if(sliderElement.hasAttribute('data-nav')){
      let thumbSlider = document.querySelector('.'+sliderElement.getAttribute('data-nav'));
      if(!thumbSlider){
        return;
      }
      let thumbSliderOptions = thumbSlider.getAttribute('data-slider');
      thumbSliderOptions = JSON.parse(thumbSliderOptions);
      thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);

      sliderOptions.thumbs = {
        swiper: thumbSlider
      }
    }

    let slider = new Swiper(sliderElement, sliderOptions);
    // Trigger Event when slide is changed
    slider.on('slideChange', (event) => {
      const currentTarget = event.el;
      if(currentTarget.querySelectorAll('custom-video.show--video').length > 0){
        let customActiveVideo = currentTarget.querySelectorAll('custom-video.show--video');
        customActiveVideo.forEach((video)=>{
          let videoType = video.getAttribute('data-video-type');
          let videoEle = video.querySelector('video') || video.querySelector('iframe');
          if(videoType == 'local'){
            videoEle.pause();
          }else if(videoType == 'youtube'){
            videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }else{
            video.toggleView();
          }
        });
      }
    });

    if(sliderElement.classList.contains('pdp-carousel')){
      productSlider = slider;
    }
    if(sliderElement.hasAttribute('data-nav') && thumbSlider){
      thumbSlider.controller.control = slider;
    }
  }
}
customElements.define('slider-element', sliderElement);////COMIENZA CODIGO AGREGADO PARA EL MENU
///////////////////////////////////////////

// Helpers de focus para el drawer del menú
const headerTrapFocusHandlers = {};

function trapFocus(container, elementToFocus) {
  if (!container) return;

  const focusableSelectors =
    'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), input:not([type="hidden"]):enabled, select:enabled, textarea:enabled';

  const focusableElements = Array.from(
    container.querySelectorAll(focusableSelectors)
  ).filter(
    (el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden')
  );

  if (!focusableElements.length) {
    (elementToFocus || container).focus();
    return;
  }

  const first = focusableElements[0];
  const last = focusableElements[focusableElements.length - 1];

  // Limpiar cualquier trap anterior
  removeTrapFocus();

  headerTrapFocusHandlers.keydown = (event) => {
    if (event.code.toUpperCase() !== 'TAB') return;

    if (event.shiftKey) {
      // Shift + Tab
      if (document.activeElement === first || document.activeElement === container) {
        event.preventDefault();
        last.focus();
      }
    } else {
      // Tab normal
      if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  headerTrapFocusHandlers.focusin = (event) => {
    if (!container.contains(event.target)) {
      first.focus();
    }
  };

  document.addEventListener('keydown', headerTrapFocusHandlers.keydown);
  document.addEventListener('focusin', headerTrapFocusHandlers.focusin);

  (elementToFocus || first).focus();
}

function removeTrapFocus(elementToFocus) {
  if (headerTrapFocusHandlers.keydown) {
    document.removeEventListener('keydown', headerTrapFocusHandlers.keydown);
  }
  if (headerTrapFocusHandlers.focusin) {
    document.removeEventListener('focusin', headerTrapFocusHandlers.focusin);
  }

  headerTrapFocusHandlers.keydown = null;
  headerTrapFocusHandlers.focusin = null;

  if (elementToFocus && typeof elementToFocus.focus === 'function') {
    elementToFocus.focus();
  }
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    
    this.drawerEl =
      this.mainDetailsToggle.querySelector('#menu-drawer') ||
      this.mainDetailsToggle.querySelector('.menu-drawer');


    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;

    // Si el menú principal está en animación de cierre, ignoramos clicks
    if (detailsElement === this.mainDetailsToggle && detailsElement.classList.contains('is-closing')) {
      event.preventDefault();
      return;
    }

    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const addTrapFocus = () => {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    };

    if (detailsElement === this.mainDetailsToggle) {
      // Abrir / Cerrar menú principal
      if (isOpen) {
        event.preventDefault();
        this.closeMenuDrawer(event, summaryElement);
      } else {
        // ✅ limpiar estado de cierre ANTES de abrir
        this.mainDetailsToggle.classList.remove('is-closing');
        this.openMenuDrawer(summaryElement);
      }

      // ✅ ojo: faltaba .matches
      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }

      return;
    } else {
      // Submenús
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', 'true');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        if (!reducedMotion || !reducedMotion.matches) {
          summaryElement.nextElementSibling.addEventListener(
            'transitionend',
            addTrapFocus
          );
        } else {
          addTrapFocus();
        }
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    this.mainDetailsToggle.classList.remove('is-closing');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', 'true');
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  // 🔧 Parche: cerramos SIEMPRE, aunque event sea undefined
  closeMenuDrawer(event, elementToFocus = null) {
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);

    const focusTarget =
      elementToFocus || this.mainDetailsToggle.querySelector('summary');

    removeTrapFocus(focusTarget);
    this.closeAnimation(this.mainDetailsToggle);

    if (focusTarget) {
      focusTarget.setAttribute('aria-expanded', 'false');
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      ) {
        this.closeMenuDrawer();
      }
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    const summary = detailsElement.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
      removeTrapFocus(summary);
    }
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    // Submenús: mantener comportamiento actual (cierre directo)
    if (detailsElement !== this.mainDetailsToggle) {
      detailsElement.removeAttribute('open');

      const openParent = detailsElement.closest('details[open]');
      if (openParent) {
        const parentSummary = openParent.querySelector('summary');
        trapFocus(openParent, parentSummary);
      }
      return;
    }

    // Menú principal: cierre animado
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const duration = prefersReduced ? 0 : 320; // debe matchear el CSS (transform 320ms)

    // Si no tenemos drawer o ya está cerrado, fallback
    const drawer = this.drawerEl;
    if (!drawer || !detailsElement.hasAttribute('open') || duration === 0) {
      detailsElement.classList.remove('is-closing');
      detailsElement.removeAttribute('open');
      return;
    }

    // Activar estado de cierre (CSS anima)
    detailsElement.classList.add('is-closing');

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      detailsElement.classList.remove('is-closing');
      detailsElement.removeAttribute('open'); // ahora sí, al final
    };

    const onEnd = (e) => {
      if (e.target !== drawer) return;
      if (e.propertyName !== 'transform' && e.propertyName !== 'opacity') return;
      drawer.removeEventListener('transitionend', onEnd);
      finish();
    };

    drawer.addEventListener('transitionend', onEnd);

    // Safety timeout (por si transitionend no dispara)
    setTimeout(() => {
      drawer.removeEventListener('transitionend', onEnd);
      finish();
    }, duration + 80);
  }

}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset ||
      (this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
        ? 1
        : 0);
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', 'true');
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    // Si no se pasa un elemento, usamos el summary principal
    const focusTarget =
      elementToFocus || this.mainDetailsToggle.querySelector('summary');
    super.closeMenuDrawer(event, focusTarget);
    if (this.header) {
      this.header.classList.remove('menu-open');
    }
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    if (this.header) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    }
    document.documentElement.style.setProperty(
      '--viewport-height',
      `${window.innerHeight}px`
    );
  };
}

customElements.define('header-drawer', HeaderDrawer);



////COMIENZA CODIGO PARA SLIDER
///////////////////////////////////////////




(() => {
  const MQ_MOBILE = window.matchMedia("(max-width: 749px)");
  const OVERLAY_SELECTORS = [
    ".gl-filter-search-fullscreen",
    ".gf-search-fullscreen",
    "[class*='filter-search-fullscreen']",
    "[id*='filter-search-fullscreen']",
    "[class*='gl-filter-search']"
  ];

  const OVERLAY_COMBINED = OVERLAY_SELECTORS.join(",");

let __origFocus = null;
let __focusGuardEnabled = false;

const enableFocusGuard = () => {
  if (__focusGuardEnabled) return;

  __origFocus = HTMLElement.prototype.focus;

  HTMLElement.prototype.focus = function (...args) {
    try {
      // Solo mientras estamos en mobile + drawer abierto
      if (MQ_MOBILE.matches && isDrawerOpen()) {
        const el = this;
        if (el && el.closest && el.closest(OVERLAY_COMBINED)) {
          // Bloquea foco del overlay de Globo => evita flicker teclado
          return;
        }
      }
    } catch (e) {}

    return __origFocus.apply(this, args);
  };

  __focusGuardEnabled = true;
};

const disableFocusGuard = () => {
  if (!__focusGuardEnabled) return;
  HTMLElement.prototype.focus = __origFocus;
  __origFocus = null;
  __focusGuardEnabled = false;
};

  const isDrawerOpen = () => {
    const details = document.getElementById("Details-menu-drawer-container");
    return !!(details && details.open);
  };

  const killGloboOverlayIfAny = () => {
    if (!MQ_MOBILE.matches) return;
    if (!isDrawerOpen()) return;

    for (const sel of OVERLAY_SELECTORS) {
      document.querySelectorAll(sel).forEach((el) => {
        // Lo ocultamos y anulamos interacción por si lo vuelve a mostrar
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("pointer-events", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
      });
    }
  };

  const setupNativeDrawerSearchMobile = () => {
    if (!MQ_MOBILE.matches) return;

    const form = document.querySelector("form[data-drawer-search][data-native-search-mobile='1']");
    if (!form || form.dataset.nativeInit === "1") return;

    const input = form.querySelector("#DrawerSearchInputNative");
    const hiddenQ = form.querySelector("#DrawerSearchHiddenQ");
    const typeInput = form.querySelector("input[name='type']");
    const searchUrl = form.dataset.searchUrl || "/search";

    if (!input || !hiddenQ) return;

    form.dataset.nativeInit = "1";

    const syncHidden = () => {
      // NO disparamos eventos para no despertar a la app
      hiddenQ.value = input.value || "";
    };
    

    // Bloqueo de event bubbling para evitar listeners delegados de la app
    const stopBubbling = (e) => e.stopPropagation();

    ["pointerdown", "touchstart", "click", "focusin", "input", "keydown"].forEach((evt) => {
      input.addEventListener(evt, stopBubbling, true); // capture
    });

    input.addEventListener("input", () => {
      syncHidden();
      // Si la app intenta abrir overlay, lo matamos
      killGloboOverlayIfAny();
    });

    // En mobile, solo limpiamos overlays; NO re-enfocamos para evitar flicker del teclado
    input.addEventListener("focus", () => {
      setTimeout(() => {
        killGloboOverlayIfAny();
      }, 0);
    });


    const goNativeSearch = () => {
      syncHidden();

      const q = (hiddenQ.value || "").trim();
      if (!q) return;

      const typeVal = typeInput ? typeInput.value : "product";
      const url = new URL(searchUrl, window.location.origin);
      url.searchParams.set("type", typeVal);
      url.searchParams.set("q", q);

      window.location.href = url.toString();
    };

    // Enter => búsqueda nativa
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        goNativeSearch();
      }
    });

    // Submit (por si algún navegador lo dispara) => búsqueda nativa
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      goNativeSearch();
    });

    // Si la app intenta insertar overlays en el DOM mientras el drawer está abierto, los escondemos
    const mo = new MutationObserver(() => killGloboOverlayIfAny());
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Primera limpieza
    killGloboOverlayIfAny();
  };

  
  document.addEventListener("DOMContentLoaded", setupNativeDrawerSearchMobile);

  // Cuando se abre el drawer (<details>), re-seteamos
  document.addEventListener(
    "toggle",
    (e) => {
      const el = e.target;
      if (el && el.id === "Details-menu-drawer-container") {
        if (el.open) {
          enableFocusGuard();

          setTimeout(setupNativeDrawerSearchMobile, 0);
          setTimeout(killGloboOverlayIfAny, 50);
          setTimeout(killGloboOverlayIfAny, 200);
        } else {
          disableFocusGuard();
        }
      }
    },
    true
  );


  // Si rotás pantalla / cambia breakpoint
  MQ_MOBILE.addEventListener?.("change", () => {
    setTimeout(setupNativeDrawerSearchMobile, 0);
    setTimeout(killGloboOverlayIfAny, 50);
  });
})();

